import Card, { CardTitle } from "./Card";
import React, { useState } from "react";
import { AUDIENCE_TYPES, AUDIENCE_TYPES_ARRAY } from "../../posts/constants";
import DonutGraph from "components/DonutGraph";
import CompareModal from "./CompareModal";
import { COLORS } from "utils/styles.js";
import { getAudienceEmoji } from "posts/constants";

export default function PoliticalPartyCard({ activeAudience }) {
  const renderData = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        // Note: Color is added for the onMouseOver() function in DonutGraph component
        return [
          { x: "Democrat (D)", y: 30, color: "#B3E1E5", initials: "D" },
          { x: "Republican (R)", y: 36, color: "#8CD3D9", initials: "R" },
          { x: "Independent (I)", y: 29, color: "#66C4CC", initials: "I" },
          { x: "Declined (N/A)", y: 4, color: "#40B5BF", initials: "N/A" },
        ];
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return [
          { x: "Democrat (D)", y: 5, color: "#FFD8CC", initials: "D" },
          { x: "Republican (R)", y: 66, color: "#FFB399", initials: "R" },
          { x: "Independent (I)", y: 23, color: "#FF8C66", initials: "I" },
          { x: "Declined (N/A)", y: 5, color: "#FF6633", initials: "N/A" },
        ];
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return [
          { x: "Democrat (D)", y: 67, color: "#FFE6FF", initials: "D" },
          { x: "Republican (R)", y: 3, color: "#FFCCFF", initials: "R" },
          { x: "Independent (I)", y: 24, color: "#FFB3FF", initials: "I" },
          { x: "Declined (N/A)", y: 5, color: "#FF99FF", initials: "N/A" },
        ];
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return [
          { x: "Democrat (D)", y: 63, color: "#E0D3B8", initials: "D" },
          { x: "Republican (R)", y: 8, color: "#D1BD94", initials: "R" },
          { x: "Independent (I)", y: 26, color: "#C2A770", initials: "I" },
          { x: "Declined (N/A)", y: 4, color: "#B3914D", initials: "N/A" },
        ];
    }
  };

  const renderColorScale = (audience) => {
    switch (audience) {
      case AUDIENCE_TYPES.TOUGH_COOKIES:
        return COLORS.TOUGH_COOKIES_PALETTE;
      case AUDIENCE_TYPES.DONT_TREAD_ON_ME:
        return COLORS.DONT_TREAD_ON_ME_PALETTE;
      case AUDIENCE_TYPES.PEOPLE_POWER:
        return COLORS.PEOPLE_POWER_PALETTE;
      case AUDIENCE_TYPES.IF_YOU_SAY_SO:
        return COLORS.IF_YOU_SAY_SO_PALETTE;
    }
  };

  const data = renderData(activeAudience);
  const colors = renderColorScale(activeAudience);

  const [showCompare, setShowCompare] = useState(false);

  return (
    <Card>
      <CardTitle
        onCompareClick={() => {
          setShowCompare(true);
        }}
      >
        Political Party
      </CardTitle>

      <DonutGraph
        name="politicalPartyChart"
        data={data}
        colors={colors}
        extras=""
      />

      <CompareModal
        centered
        size="xl"
        show={showCompare}
        onHide={() => {
          setShowCompare(false);
        }}
      >
        <CompareModal.Header closeButton>
          <CompareModal.Title>
            Compare Audiences – Political Party
          </CompareModal.Title>
        </CompareModal.Header>{" "}
        <CompareModal.Body>
          <CompareModal.Grid>
            {AUDIENCE_TYPES_ARRAY.map((type, i) => {
              return (
                <CompareModal.GridColumn key={`political-party-compare-${i}`}>
                  <CompareModal.GridColumnTitle>
                    {getAudienceEmoji(type)}
                    {type}
                  </CompareModal.GridColumnTitle>
                  <CompareModal.GridColumnContent>
                    <DonutGraph
                      colors={renderColorScale(type)}
                      data={renderData(type)}
                      extras=""
                    />
                  </CompareModal.GridColumnContent>
                </CompareModal.GridColumn>
              );
            })}
          </CompareModal.Grid>
        </CompareModal.Body>
      </CompareModal>
    </Card>
  );
}
